export const parseQrCode = (response: { data: { qrimageurl: string } }) => response.data.qrimageurl;
